// export const returnCategoryNames = category => category.map(({ item }) => item.name);

import { BlogCategory } from '@tovia/man-protos/dist/types/content.types';

export const renderPostItemProps = ({
  item,
  timezone,
  truncated,
  className,
  isSinglePost,
}: {
  item: {
    path: string;
    UUID: string;
    title: string;
    content: string;
    author: string;
    commentsCount: number;
    categories: BlogCategory[];
    publishedAt: string;
  };
  timezone: string;
  truncated?: boolean;
  className?: string;
  isSinglePost?: boolean;
}) => ({
  blogUrl: `${item.path}`,
  timezone,
  key: item.UUID,
  truncated,
  name: item.title,
  text: item.content,
  author: item.author,
  commentCount: item.commentsCount,
  categories: item.categories,
  publishedAt: item.publishedAt,
  className,
  isSinglePost,
});
